export default "__VITE_ASSET__a1489f97__"